export default __webpack_public_path__ + "static/titilliumweb-light-webfont-c0afd2cec899f250f63886648fa0bb59.woff2";